import { AnalyticsConfig, configureAnalytics } from '@lovejunk/core'

import { logEvent } from '../utils/firebase/analytics'

const config: AnalyticsConfig = { logEvent }

export default () => configureAnalytics(config)
